module.exports = __webpack_public_path__ + "static/Ananda Nadya-d459a5061f3da2e7fe8a4b33c80d8235.jpg";